import { rem } from '@mantine/core';
import cx from 'clsx';
import { CSSProperties, useMemo } from 'react';

import { AccessControlledImage } from '../../../utilities/AccessControlledImage';
import { FileTypes } from '../FileTypes';
import classes from '../UploadFile.module.scss';

type FilePreviewProps = {
  type: FileTypes;
  alt: string;
  src: string;
  previewMaxHeight?: number;
  aspectRatio?: string;
  disabled?: boolean;
  isThumbnail?: boolean;
  customClassName?: string;
  dataTestId?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none';
};

export function FilePreview(props: FilePreviewProps) {
  const {
    type,
    alt,
    src,
    previewMaxHeight = 400,
    aspectRatio,
    disabled,
    isThumbnail,
    customClassName,
    dataTestId,
    objectFit = 'cover'
  } = props;
  const style = useMemo(
    () =>
      ({
        '--upload-max-height': rem(previewMaxHeight),
        '--upload-aspect-ratio': aspectRatio
      } as CSSProperties),
    [previewMaxHeight, aspectRatio]
  );

  return (
    type === 'image' &&
    src &&
    (isThumbnail ? (
      <AccessControlledImage
        variant="mantine"
        alt={alt}
        src={src}
        fit={objectFit}
        style={style}
        className={cx(classes.image, disabled && classes.disabled, classes.thumbnail, customClassName)}
        dataTestId={dataTestId ?? 'image-preview'}
      />
    ) : (
      <AccessControlledImage
        variant="unpic"
        alt={alt}
        src={src}
        width={400}
        height={previewMaxHeight}
        objectFit={objectFit}
        className={cx(classes.image, disabled && classes.disabled, customClassName)}
        dataTestId={dataTestId ?? 'image-preview'}
      />
    ))
  );
}
